/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Sign_In_ActionInputs */

const en_directory_promotion_sign_in_action = /** @type {(inputs: Directory_Promotion_Sign_In_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const zh_directory_promotion_sign_in_action = /** @type {(inputs: Directory_Promotion_Sign_In_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Directory_Promotion_Sign_In_ActionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_sign_in_action = /** @type {((inputs?: Directory_Promotion_Sign_In_ActionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Sign_In_ActionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_sign_in_action(inputs)
	return zh_directory_promotion_sign_in_action(inputs)
});
export { directory_promotion_sign_in_action as "directory.promotion.sign_in_action" }